import { FormResponse } from '../types/form';

export function calculateDepositFromRent(monthlyRent: number): number {
  if (!monthlyRent || monthlyRent <= 0) return 0;

  const weeklyRent = monthlyRent / (52 / 12);
  const fiveWeeksDeposit = Math.round(weeklyRent * 5);

  return fiveWeeksDeposit;
}

export function calculateRentIncrease(currentRent: number, percentage: number = 5): number {
  if (!currentRent || currentRent <= 0) return 0;

  return Math.round(currentRent * (1 + percentage / 100));
}

export function suggestRentIncreasePercentage(currentRent: number, newRent: number): string {
  if (!currentRent || !newRent || currentRent <= 0) return '0%';

  const percentage = ((newRent - currentRent) / currentRent) * 100;
  return `${percentage.toFixed(1)}%`;
}

export function getSmartDefault(
  fieldId: string,
  responses: FormResponse
): string | number | undefined {
  switch (fieldId) {
    case 'depositAmount':
      const rentAmount = responses['rentAmount'] as number;
      if (rentAmount) {
        return calculateDepositFromRent(rentAmount);
      }
      break;

    case 'advertisedRent':
      const currentRentForAd = responses['rentAmount'] as number;
      if (currentRentForAd) {
        return currentRentForAd;
      }
      break;

    case 'newRent':
      const currentRent = responses['currentRent'] as number;
      if (currentRent) {
        return calculateRentIncrease(currentRent, 5);
      }
      break;

    case 'rentPerStudent':
      const totalRent = responses['rentAmount'] as number;
      const numberOfStudents = responses['numberOfStudents'] as number;
      if (totalRent && numberOfStudents && numberOfStudents > 0) {
        return Math.round(totalRent / numberOfStudents);
      }
      break;

    case 'deposit':
      const annualRent = responses['rentAmount'] as number;
      if (annualRent) {
        const monthlyEquivalent = annualRent / 12;
        return calculateDepositFromRent(monthlyEquivalent) * 3;
      }
      break;
  }

  return undefined;
}

export function getSmartDefaultHint(fieldId: string, responses: FormResponse): string | undefined {
  switch (fieldId) {
    case 'depositAmount':
      const rentAmount = responses['rentAmount'] as number;
      if (rentAmount) {
        const deposit = calculateDepositFromRent(rentAmount);
        return `Suggested: £${deposit} (5 weeks of £${rentAmount}/month)`;
      }
      break;

    case 'advertisedRent':
      const currentRentForAd = responses['rentAmount'] as number;
      if (currentRentForAd) {
        return `Should match monthly rent: £${currentRentForAd}`;
      }
      break;

    case 'newRent':
      const currentRent = responses['currentRent'] as number;
      if (currentRent) {
        const suggested = calculateRentIncrease(currentRent, 5);
        return `Suggested 5% increase: £${suggested}`;
      }
      break;

    case 'rentPerStudent':
      const totalRent = responses['rentAmount'] as number;
      const numberOfStudents = responses['numberOfStudents'] as number;
      if (totalRent && numberOfStudents && numberOfStudents > 0) {
        const perStudent = Math.round(totalRent / numberOfStudents);
        return `Split equally: £${perStudent} per student`;
      }
      break;
  }

  return undefined;
}
